<template>
  <div class="bubble-menu-dropdown" ref="dropdown">
    <button
      class="bbl-dropdown-trigger"
      @click="toggleDropdown"
      :class="{ active: isOpen }"
    >
      <slot name="trigger">
        <span>{{ label }}</span>
      </slot>
      <svg 
        class="dropdown-arrow" 
        :class="{ open: isOpen }"
        width="12" 
        height="12" 
        viewBox="0 0 12 12" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2"
      >
        <polyline points="2,4 6,8 10,4"/>
      </svg>
    </button>
    
    <div v-if="isOpen" class="bbl-dropdown-menu" :style="menuStyle">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="bbl-dropdown-item"
        :class="{ active: item.active, disabled: item.disabled }"
        @click="handleItemClick(item)"
      >
        <component v-if="item.icon" :is="item.icon" class="item-icon" :width="16" :height="16" />
        <span class="bbl-item-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BubbleMenuDropdown',
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true,
      // items: [{ label: 'Item', icon: Component, action: Function, active: Boolean, disabled: Boolean }]
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    menuStyle() {
      return {
        minWidth: '180px'
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    
    handleItemClick(item) {
      if (item.disabled) return
      
      if (item.action && typeof item.action === 'function') {
        item.action()
      }
      
      this.isOpen = false
    },
    
    handleClickOutside(e) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(e.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
.bubble-menu-dropdown {
  position: relative;
  display: inline-block;
}

.bbl-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.bbl-dropdown-trigger:hover {
  background: #f3f4f6;
}

.bbl-dropdown-trigger.active {
  background: #dbeafe;
  color: #2563eb;
}

.dropdown-arrow {
  transition: transform 0.2s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.bbl-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 4px;
  z-index: 1000;
  min-width: 150px;
}

.bbl-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 13px;
  color: #374151;
}

.bbl-dropdown-item:hover:not(.disabled) {
  background: #f3f4f6;
}

.bbl-dropdown-item.active {
  background: #dbeafe;
  color: #2563eb;
}

.bbl-dropdown-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.item-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.bbl-item-label {
  flex: 1;
}
</style>
